<script>
export default {
  name: "Separator",
}
</script>

<template>
  <div class="separator"></div>
</template>

<style scoped>
.separator {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border-top: 1px solid lightgrey;
  width: 100%;
}
</style>